import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Button } from 'react-bootstrap';

import { certificationActions } from 'store/slices/certification/certificationSilce';
import styles from 'assets/scss/wizard/emetBreak.module.scss';

/**
 * @component Break
 * @description
 * Componente de pausa que se muestra entre secciones del examen.
 * Permite al usuario tomar un breve descanso o continuar de inmediato.
 * Si el temporizador llega a cero (`timeOver`), el examen continúa automáticamente.
 *
 * @returns {JSX.Element}
 *
 * @example
 * <Break />
 */
const Break = () => {
	const dispatch = useDispatch();
	const { timeOver } = useSelector(state => state.certificationReducer);

	useEffect(() => {
		if (timeOver) {
			handleSkipBreak();
		}
	}, [timeOver]);

	/**
	 * Avanza al siguiente paso del examen.
	 * Detiene y reinicia el temporizador para la siguiente sección.
	 */
	const handleSkipBreak = () => {
		dispatch(certificationActions.incrementStep());
		dispatch(certificationActions.setStartTimer(false));
		dispatch(certificationActions.setTimeOver(false));
		setTimeout(() => {
			dispatch(certificationActions.setStartTimer(true));
		}, 50);
	};

	/**
	 * Contenido visual del componente de descanso.
	 * Muestra el mensaje, instrucciones y botón para continuar.
	 *
	 * @param {Function} handleSkipBreak - Función que permite saltar el descanso.
	 * @returns {JSX.Element}
	 */
	const renderBreakContent = (handleSkipBreak) => (
		<Row className="align-items-center justify-content-center mt-5">
			<Col lg={12} className="text-center">
				<h2 className={`${styles.breakMessage} mb-4`}>Break</h2>
				<p className={`${styles.instructions} mb-5`}>
					Esta pausa te permitirá tomar un breve descanso antes de continuar con la siguiente sección del examen.
					Asegúrate de estar listo antes de reanudar. Si prefieres, puedes saltar esta pausa y continuar de inmediato.
				</p>
				<Button
					variant="primary"
					size="lg"
					onClick={handleSkipBreak}
					className={styles.skipButton}
				>
					Saltar y Continuar
				</Button>
			</Col>
		</Row>
	);

	return renderBreakContent(handleSkipBreak);
};

export default Break;